const THREE = require('three')
import GradientWipe from './GradientWipe'


// GRADIENT
export let gradientWipe = new GradientWipe()

// GEOMETRY
let geometry = new THREE.PlaneBufferGeometry(window.innerWidth * 3, window.innerHeight * 3)

// MATERIAL
let texture = new THREE.Texture(gradientWipe.canvas)
let material = new THREE.MeshBasicMaterial({
  map: texture,
  transparent: true,
  side: THREE.DoubleSide
})

// MESH
export let mesh = new THREE.Mesh(geometry, material)
mesh.name = 'result-bg'
export default mesh
const s = 1
mesh.scale.set(s, s, s)

// DRAW
export const draw = function(color, time = 1.2) {
  return gradientWipe.draw(color, time, ()=> {
    material.needsUpdate = true
    texture.needsUpdate = true
  })
}




// WEBPACK FOOTER //
// ./src/components/game/result/bg.js